import { Card } from 'react-bootstrap';

import { BalanceThresholdForm } from '@components/Forms/BalanceThresholdForm/BalanceThresholdForm';

export const BalanceThreshold = ({
  currentThreshold,
  currentThresholdValue,
}) => (
  <Card>
    <Card.Header className="bg-didxl text-white">
      Change the notification threshold
    </Card.Header>
    <Card.Body>
      <BalanceThresholdForm
        currentThreshold={currentThreshold}
        currentThresholdValue={currentThresholdValue}
      />
    </Card.Body>
  </Card>
);
